<template>
    <div class="sss_zhuanlan">
        <div class="left">
            <div class="header">
                <div class="user">
                    <img class="avatar" :src="baseUrl + basicInformation.avatar" alt="头像" />
                    <div>
                        <div class="name">{{ basicInformation.userName }} (技巧师)</div>
                        <div class="content">
                            <div>
                                <div>双色球：</div>
                                <div>大乐透：</div>
                                <div class="lastDiv">缩水列表</div>
                            </div>
                            <div>
                                <div>福彩3D</div>
                                <div>体彩排三</div>
                                <div class="lastDiv">历史成绩</div>
                            </div>
                            <div>
                                <div>缩币文章</div>
                                <div>浏览人数</div>
                                <div class="lastDiv">加入关注</div>
                            </div>
                            <div>
                                <div>免费预测</div>
                                <div>粉丝人数</div>
                                <div class="lastDiv">放入桌面</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="msg">作为缩水师的我最喜欢的座右铭：<div>{{ basicInformation.motto }}</div>
                </div>
            </div>

            <div class="table1">
                <div class="tit">
                    <div>最新预测</div><span>更多预测</span>
                </div>
                <el-table size="mini" :data="techListData" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
                    <el-table-column label="序号" type="index" width="50" />
                    <el-table-column label="最新EXCEL图表" prop="title" width="250" />
                    <el-table-column label="类型" prop="isWin" min-width="90" />
                    <el-table-column label="发布时间" prop="createTime" width="180" />
                    <el-table-column label="操作" min-width="80">
                        <el-button type="text" size="small"
                            @click="handleDownload(item, item.preIndexType, item.preIndexTypeName, item.preIndexTypeAlies)">查阅</el-button>
                    </el-table-column>

                </el-table>
            </div>
            <div class="table2">
                <div class="tit">
                    <div>
                        <span>近期成绩</span>
                        <span>双色球</span>
                        <span>福彩3D</span>
                        <span>大乐透</span>
                        <span>排列三</span>
                    </div>
                    <span>更多预测</span>
                </div>

                <el-table size="mini" :data="historyListData" :header-cell-style="headerCellStyle"
                    :cell-style="cellStyle">
                    <el-table-column label="期号" width="50" />
                    <el-table-column label="分析型红表" prop="title" min-width="110" />
                    <el-table-column label="分析型蓝表" prop="isWin" min-width="110" />
                    <el-table-column label="排序型红表" prop="createTime" min-width="110" />
                    <el-table-column label="排序型蓝表" prop="createTime" min-width="110" />
                    <el-table-column label="红表准确率" prop="createTime" min-width="110" />
                    <el-table-column label="蓝表准确率" prop="createTime" min-width="110" />
                    <el-table-column label="红蓝总准确率" prop="createTime" width="120" />
                </el-table>

            </div>

        </div>
        <div class="right">
            <div v-for="(item, index) in cebian" :key="index">
                <div class="tit">{{ item.title }}</div>
                <ul>
                    <li v-for="(ite, idx) in item.arr" :key="idx" @click="tiaozhuan(ite.name)">
                        {{ ite.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { getInfo, techList, techScore} from "@/api/hangjiaguanli"
import tableMixin from '@/views/homePage/menu/suoshuidan_dating/table/mixin.js'
export default {
    mixins: [tableMixin],
    data() {
        return {
            cebian: [
                {
                    title: "缩水单大厅",
                    arr: [
                        { name: "申请缩水师" },
                        { name: '缩水单大厅双色球学霸VIP区' },
                        { name: '缩水单大厅大乐透学霸VIP区' },
                        { name: '缩水单大厅3D学霸VIP区' },
                        { name: '缩水单大厅排列三学霸VIP区' },
                    ]
                },
                {
                    title: "EXCEL专区",
                    arr: [
                        { name: '申请技巧师' },
                        { name: 'EXCEL专区双色球VIP区' },
                        { name: 'EXCEL专区大乐透VIP区' },
                        { name: 'EXCEL专区3D-VIP区' },
                        { name: 'EXCEL专区排列三VIP区' },
                        { name: '闲置EXCEL改表,修复申请' },
                        { name: '定制EXCEL表申请' },
                    ]
                },
                // {
                //     title: "缩水软件特区",
                //     arr: [
                //         { name: '申请软件交易师' },
                //         { name: '免费软件区' },
                //         { name: '缩水软件VIP区' },
                //         { name: '缩水软件（个人/众筹）定制' },
                //     ]
                // },
                // {
                //     title: "实体投注站帮扶中心",
                //     arr: [
                //         { name: '彩票投注站申请帮扶' },
                //         { name: '彩票代表申请' },
                //         { name: '彩票代表申请' },
                //         { name: '实战超市（仅限彩票投注站认购）' },
                //         { name: '众筹招股大厅' }
                //     ]
                // },
            ],

            baseUrl: process.env.VUE_APP_BASE_API,

            // 基本信息
            basicInformation: {},
            // 表格表头样式
            headerCellStyle: {
                textAlign: 'center',
                backgroundColor: '#F2F2F2',
                color: '#951d1d',
                fontWeight: 'bold',
            },
            cellStyle: {
                textAlign: 'center',
            },

            // 最新预测参数
            techParams: {
                pageNum: 1,
                pageSize: 10,
                startDate: '',
                endDate: '',
                numbe: '',
                preType: '',
            },
            // 最新预测数据
            techListData: [],

            // 历史成绩参数
            historyParams: {
                "preType": "0",
                "preIndexType": "1",
                "createUser": '',
                "createUserType": "1"
            },
            // 历史成绩数据
            historyListData: [],

        }
    },
    mounted() {
        this.getUserInfo();
        this.getTechList();
        this.getTechScore();
    },
    methods: {
        async getUserInfo() {
            const { data } = await getInfo({
                userId: this.vuex_userInfo.userId
            })
            this.basicInformation = data
        },

        async getTechList() {
            const { rows, total } = await techList(this.techParams)
            this.techListData = rows
        },

        async getTechScore() {
            this.historyParams.createUser = this.vuex_userInfo.userId
            const xxx = await techScore(this.historyParams)
            console.log(xxx);
            
            // this.historyListData = rows
        },

        

        tiaozhuan(temp) {

            const mapping = {
                // 缩水单大厅
                '申请缩水师': '/personalCenter/hangjiaguanli/apply_sss',
                '缩水单大厅双色球半免费区': '/ssddt?caizhong=sss',
                '缩水单大厅大乐透半免费区': '/ssddt?caizhong=dlt',
                '缩水单大厅3D半免费区': '/ssddt?caizhong=3d',
                '缩水单大厅排列三半免费区': '/ssddt?caizhong=pl3',

                // EXCEL专区
                '申请技巧师': '/personalCenter/hangjiaguanli/apply_jqs',
                'EXCEL专区双色球VIP区': '/excel?caizhong=sss',
                'EXCEL专区大乐透VIP区': '/excel?caizhong=dlt',
                'EXCEL专区3D-VIP区': '/excel?caizhong=3d',
                'EXCEL专区排列三VIP区': '/excel?caizhong=pl3',
                '闲置EXCEL改表,修复申请': '/excel?caizhong=xianzhi',
                '定制EXCEL表申请': '/excel?caizhong=xianzhi',

                // 缩水软件特区
                // '申请软件交易师':'/personalCenter/hangjiaguanli/apply_software',
                // '免费软件区':'/software',
                // '缩水软件VIP区':'/software?vip=1',
                // '缩水软件（个人/众筹）定制':'/personalCenter/hangjiaguanli/software_custom',

                // 实体投注站帮扶中心
                // '彩票投注站申请帮扶':'/personalCenter/hangjiaguanli/apply_betting_site',
                // '彩票代表申请':'/personalCenter/hangjiaguanli/apply_lottery_representative',
                // '实战超市（仅限彩票投注站认购）':'/personalCenter/hangjiaguanli/apply_real_estate',
                // '众筹招股大厅':'/personalCenter/hangjiaguanli/apply_crowd_funding',

            }

            this.$router.push(mapping[temp])

        },
    }
}
</script>

<style lang="scss" scoped>
.sss_zhuanlan {
    display: flex;

    >div {
        border: 1px solid;
    }

    .left {
        flex: 1;

        .header {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);

            .user {
                display: flex;

                .avatar {
                    width: 100px;
                    height: 100px;
                    margin-right: 10px;
                    border: 1px solid red;
                }

                >div {
                    flex: 1;

                    .name {
                        color: #bd312a;
                        font-weight: bold;
                    }

                    .content {
                        display: flex;
                        justify-content: space-between;

                        .lastDiv {
                            margin-top: 15px;
                            background-color: #93d2f3;
                            padding: 5px 10px;
                        }
                    }
                }
            }

            .msg {
                color: #bd312a;
                margin: 10px 0;
                display: flex;

                >div {
                    flex: 1;
                    border-bottom: 1px solid #bd312a;
                }
            }
        }

        .table1 {
            .tit {
                display: flex;
                justify-content: space-between;
                background-color: #93d2f3;
                color: #951d1d;
                padding: 5px 10px;
            }

            .grid {
                font-size: 12px;

                >div {
                    display: grid;
                    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
                    text-align: center;
                    padding: 10px 0;

                    &:nth-child(odd) {
                        background-color: #f2f2f2;
                    }
                }
            }
        }

        .table2 {
            .tit {
                display: flex;
                justify-content: space-between;
                background-color: #93d2f3;
                color: #951d1d;
                padding: 5px 10px;

                span {
                    margin-right: 10px;
                }
            }

            .grid {
                font-size: 12px;

                >div {
                    display: grid;
                    grid-template-columns: repeat(8, 1fr);
                    text-align: center;

                    span {
                        padding: 5px 0;
                        border: 1px solid rgba(0, 0, 0, 0.2);
                    }
                }
            }
        }
    }

    .right {
        width: 200px;
        text-align: center;

        .tit {
            background-color: #93d2f3;
            color: #951d1d;
            border-bottom: 1px solid #951d1d;
            font-weight: bold;
            font-size: 12px;
            padding: 10px 0;
        }

        ul {
            padding: 0;
            margin: 0;
            list-style: none;

            li {
                border-bottom: 1px solid #951d1d;
                padding: 10px 0;
                cursor: pointer;
                font-size: 12px;
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .sss_zhuanlan {
        /* 左右两栏改为上下排列 */
        flex-direction: column;

        .left {
            .header {
                padding: 8px;

                .user {
                    .avatar {
                        width: 56px;
                        height: 56px;
                        margin-right: 8px;
                    }

                    /* 数据统计：四列改两列 */
                    .content {
                        flex-wrap: wrap;

                        >div {
                            width: 50%;
                        }
                    }
                }

                .msg {
                    margin: 8px 0;
                    font-size: 13px;
                }
            }

            /* 两张数据表 */
            .table1,
            .table2 {
                margin-top: 8px;

                .tit {
                    flex-wrap: wrap;
                    row-gap: 6px;
                    padding: 6px 8px;
                    align-items: flex-start;

                    >div {
                        flex: 1;
                        min-width: 0;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 6px;

                        /* 「近期成绩」标题独占一行，4 个彩种换到第二行 */
                        >span:first-child {
                            width: 100%;
                        }
                    }

                    span {
                        margin-right: 0;
                        padding: 3px 8px;
                        font-size: 12px;
                    }
                }
            }
        }

        /* 右侧栏目：占满整行，链接横向排列 */
        .right {
            width: 100%;
            margin-top: 8px;

            >div {
                padding: 6px 8px;
            }

            .tit {
                padding: 6px 8px;
                text-align: left;
                font-size: 13px;
            }

            ul {
                display: flex;
                flex-wrap: wrap;

                li {
                    padding: 6px 10px;
                    border: 1px solid rgba(149, 29, 29, 0.3);
                    border-radius: 4px;
                    margin: 4px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
